var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          minWidth: _vm.getMinWidth,
          maxWidth: _vm.getMaxWidth,
          minHeight: "80vh"
        },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      model: {
        value: _vm.show_welcome,
        callback: function($$v) {
          _vm.show_welcome = $$v
        },
        expression: "show_welcome"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.welcome_banner.title) +
                    "\n            "
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "layout-padding" }, [
            _c("div", { staticClass: "row gutter-md" }, [
              _vm.getBanner
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12 text-center" },
                    [
                      _c("img", {
                        style: _vm.bannerStyle,
                        attrs: { src: _vm.getBanner }
                      })
                    ]
                  )
                : _vm._e(),
              _vm.welcome_banner.content
                ? _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.welcome_banner.content)
                      }
                    })
                  ])
                : _vm._e()
            ]),
            _c("div", { staticClass: "row gutter-sm justify-end q-mt-sm" }, [
              _vm.welcome_banner.banner_welcome_type_slug === "user_logout"
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-3" },
                    [
                      _c("q-btn", {
                        staticClass: "full-width",
                        attrs: {
                          color: "tertiary",
                          label: _vm.$t("logout"),
                          icon: "fas fa-sign-out-alt"
                        },
                        on: {
                          click: function($event) {
                            return _vm.logout()
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.welcome_banner.banner_welcome_type_slug === "just_confirm"
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-3" },
                    [
                      _c("q-btn", {
                        staticClass: "full-width",
                        attrs: {
                          color: "primary",
                          label: _vm.$t("enter"),
                          icon: "far fa-save"
                        },
                        on: {
                          click: function($event) {
                            return _vm.confirmEnter()
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }